import { useInsightStore } from '../stores/insightStore'

export type InsightNavResetRegistrar = (reset: () => void) => void

/** B23: navigation closes transient shell chrome but deliberately keeps the workspace cache warm. */
export function registerInsightNavReset(register: InsightNavResetRegistrar): void {
  register(() => useInsightStore().closePanel())
}
